export default {
  PLAYED: 'played',
  UPCOMING: 'upcoming',
  FORFEITED: 'forfeited',
  CANCELLED: 'cancelled',
  TO_BE_PLAYED: 'to be played'
};
